import { render } from "./sub_portal.html?vue&type=template&id=98366b2c&external"
import script from "./sub_portal.js?vue&type=script&lang=js&external"
export * from "./sub_portal.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__